var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 1.667H3.333c-.833 0-1.666.75-1.666 1.666v2.509c0 .6.358 1.116.833 1.408v9.417c0 .916.917 1.666 1.667 1.666h11.666c.75 0 1.667-.75 1.667-1.666V7.25c.475-.292.833-.808.833-1.408V3.333c0-.916-.833-1.666-1.666-1.666zm-.834 15H4.167V7.5h11.666v9.167zm.834-10.834H3.333v-2.5h13.334v2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10h-5v1.667h5V10z"
  })));
}
export default SvgInventory2;